import React, { FocusEvent } from 'react';

import { adminSettingsUtils } from 'utils/selectOptionsUtils';

import { QuantityFormatSelect } from './QuantityFormatSelect';

interface IQuantityFormatBooleanFieldProps {
  header: string;
  name: string;
  value: string;
  isFetching: boolean;
  error: boolean;
  onFieldChange: (fieldPath: string, rawValue: string) => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

export const QuantityFormatBooleanField = ({
  header,
  name,
  value,
  isFetching,
  error,
  onFieldChange,
  onBlur
}: IQuantityFormatBooleanFieldProps): React.ReactElement => (
  <QuantityFormatSelect
    header={header}
    name={name}
    value={value}
    items={adminSettingsUtils.trueFalseOptions}
    isFetching={isFetching}
    error={error}
    onFieldChange={onFieldChange}
    onBlur={onBlur}
  />
);
